import React from 'react';
import { Label } from '@/components/ui/label';
import { Slider } from '@/components/ui/slider';

interface MovementStrengthSelectorProps {
  value: number;
  onChange: (strength: number) => void;
}

/**
 * MovementStrengthSelector - Controls the intensity of menu item movement effects
 */
const MovementStrengthSelector: React.FC<MovementStrengthSelectorProps> = ({
  value,
  onChange
}) => {
  const handleValueChange = (values: number[]) => {
    onChange(values[0]);
  };

  const getStrengthLabel = (strength: number) => {
    if (strength <= 0.3) return 'Subtle';
    if (strength <= 0.7) return 'Moderate';
    if (strength <= 1.2) return 'Strong';
    return 'Intense';
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <Label className="text-sm font-medium">Movement Strength</Label>
        <div className="text-xs text-gray-500">
          {getStrengthLabel(value)} ({Math.round(value * 100)}%)
        </div>
      </div>
      
      <div className="space-y-2">
        <Slider
          value={[value]}
          onValueChange={handleValueChange}
          min={0.1}
          max={2.0}
          step={0.1}
          className="w-full"
        />
        
        <div className="flex justify-between text-xs text-gray-400">
          <span>Subtle (10%)</span>
          <span>Normal (100%)</span>
          <span>Intense (200%)</span>
        </div>
      </div>
      
      <div className="text-xs text-gray-500">
        Controls the intensity of hover movement effects like lift, scale, and tilt
      </div>
    </div>
  );
};

export default MovementStrengthSelector;